import {
    environment,
    REACT_APP_7NOW_BASE_PATH,
    REACT_APP_7NOW_API_KEY,
    REACT_APP_7REWARDS_BASE_PATH,
    REACT_APP_7REWARDS_CLIENT_ID,
    REACT_APP_7REWARDS_CLIENT_SECRET,
    REACT_APP_7REWARDS_GUEST_CLIENT_ID,
    REACT_APP_7REWARDS_GUEST_CLIENT_SECRET,
    REACT_APP_7REWARDS_PASSWORD_CLIENT_ID,
    REACT_APP_7REWARDS_PASSWORD_CLIENT_SECRET,
    REACT_APP_LOCALIZATION_BASE_PATH,
} from '../../config/environment'

export const getBaseURL = () => REACT_APP_7NOW_BASE_PATH
export const getServiceKey = () => REACT_APP_7NOW_API_KEY

export const get7RBaseURL = () => REACT_APP_7REWARDS_BASE_PATH
export const getClientId = () => REACT_APP_7REWARDS_CLIENT_ID
export const getClientSecret = () => REACT_APP_7REWARDS_CLIENT_SECRET
export const getGuestClientID = () => REACT_APP_7REWARDS_GUEST_CLIENT_ID
export const getGuestSecretID = () => REACT_APP_7REWARDS_GUEST_CLIENT_SECRET
export const getPasswordClientID = () => REACT_APP_7REWARDS_PASSWORD_CLIENT_ID
export const getPasswordSecretID = () => REACT_APP_7REWARDS_PASSWORD_CLIENT_SECRET
export const getCDNURL = () => `${REACT_APP_LOCALIZATION_BASE_PATH}/delivery/7Now-Static/`

// Help center API keys

export const ZD_ACTIVE_ORDERS_SECTION_ID = () =>
    environment === 'production' ? '360012457693' : '360012448393'

export const ZD_DELIVERY_ISSUES_LIST_SECTION = () =>
    environment === 'production' ? '360011317454' : '360011307434'

export const ZD_ITEM_ISSUES_LIST_SECTION = () =>
    environment === 'production' ? '1500000266562' : '1500000256282'

export const ZD_PAST_ORDERS_IWDP_SECTION_ID = () =>
    environment === 'production' ? '1500000266542' : '1500000256262'

export const ZD_PAST_ORDERS_IWAO_SECTION_ID = () =>
    environment === 'production' ? '360011317434' : '360011307354'
